/**
 * Created by  on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
/**
 * 身份证
 * @param {*} textval 
 * @returns 
 */
export function validateIdCard(textval) {
  const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  return reg.test(textval)
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
// 对手机号进行校验
export function testPhoneRules(mobile_no) {
  if (!mobile_no) return false
  const re = /^1[3456789]\d{9}$/
  const result = re.test(mobile_no)
  return result
}
// 对账号进行校验
export function testUserNameRules(mobile_no) {
  if (!mobile_no) return false
  const reg = /^[A-Za-z0-9]+$/
  const result = reg.test(mobile_no)
  return result
}
/* 正整数 */
export function validateNumber(str) {
  const reg = /^[1-9]+[0-9]*]*$/
  return reg.test(str)
}
/* 大于零整数 */
export function validateNumberZero(str) {
  const reg = /^\d+$/
  return reg.test(str)
}
